import { initSwitchableItems } from "@plugins";

window.addEventListener(
    "load",
    initSwitchableItems(".js-sidebar-contents-tags", ".js-sidebar-contents-tags-link"),
);
